import React, { useState } from "react";
import { SbButton, SbInput, SbModal } from "uiCore";

// One modal-backed header button — "Save Plan"/"Update Plan" or "Save &
// Close Plan"/"Update & Close Plan" (closeAfter picks which pair). Shared by
// every Talent Mobility plan-drafting screen (Redeployment Center, Reduction
// Detail, Workforce Planning) — each renders it against its own
// useRedeploymentPlanActions()/useWorkforcePlanActions() instance, which is
// where the domain-specific store/API calls live; this component only knows
// hasDraft/isUpdate/planName/isSubmitting/onSave. The button's own label and
// the modal's title/confirm label all switch from Save/Create to Update the
// moment the shared draft already has a planId, so every button for that
// draft flips together the first time any one of them saves.
const PlanSaveButton = ({
  buttonType = "primary",
  closeAfter = false,
  disabled = false,
  hasDraft,
  isUpdate,
  planName,
  isSubmitting,
  onSave,
  planTypeLabel = "Plan",
}) => {
  const [open, setOpen] = useState(false);
  const [nameInput, setNameInput] = useState("");

  const label = closeAfter
    ? (isUpdate ? "Update & Close Plan" : "Save & Close Plan")
    : (isUpdate ? "Update Plan" : "Save Plan");

  const openModal = () => {
    setNameInput(isUpdate ? planName : "");
    setOpen(true);
  };

  const handleConfirm = async () => {
    const saved = await onSave(nameInput, { closeAfter });
    if (saved) setOpen(false);
  };

  return (
    <>
      <SbButton buttonType={buttonType} disabled={disabled || !hasDraft || isSubmitting} onClick={openModal}>
        {label}
      </SbButton>

      <SbModal
        open={open}
        title={`${isUpdate ? "Update" : "Create"} ${planTypeLabel}`}
        onCancel={() => !isSubmitting && setOpen(false)}
        footer={[
          <SbButton key="cancel" buttonType="secondary" disabled={isSubmitting} onClick={() => setOpen(false)}>
            Cancel
          </SbButton>,
          <SbButton key="confirm" buttonType="primary" loading={isSubmitting} onClick={handleConfirm}>
            {isUpdate ? "Update Plan" : "Create Plan"}
          </SbButton>,
        ]}
      >
        <SbInput
          placeholder="Enter plan name"
          value={nameInput}
          onChange={(e) => setNameInput(e.target.value)}
          onPressEnter={handleConfirm}
          autoFocus
        />
      </SbModal>
    </>
  );
};

export default PlanSaveButton;
